export default __webpack_public_path__ + "static/media/Hope-skip-drive-check.fd867cf2.jpg";